import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import React from "react";
import { updateSubscription } from "../../../../../services/subscriptions.service";
import { useToast } from "../../../../../ui-components/ToastProvider";
import { parseDateHifen } from "../../../../../utils/parseDate";

import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { ModalComponent } from "../../../../../ui-components/Modal";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  adminButtonOutlinedSx,
  adminButtonPrimarySx,
  adminModalSx,
} from "../../../modalStyle";

interface PreSubscription {
  id: number;
  user_id: number;
  event_id: number;
  first_time: boolean;
  start_date: Date;
  end_date: Date;
  status_id: number;
  created_at: Date;
  is_paid: boolean;
  event_space: number;
  space_type: string;
  extra_table: number;
  table_quantity: number;
  extra_chair: number;
  chair_quantity: number;
  items?: string;
  notes?: string;
  amount: number;
}

export default function UpdateButton({
  id,
  updateSubscriptions,
  sub,
}: {
  id: number;
  updateSubscriptions: Function;
  sub: PreSubscription;
}) {
  const [open, setOpen] = React.useState(false);
  const { showToast } = useToast();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const formData: any = Object.fromEntries(new FormData(e.target).entries());
    formData.is_paid = formData.is_paid === "true";
    formData.status_id = parseInt(formData.status_id);
    formData.event_space = Number(formData.event_space) || 0;
    formData.extra_table = Number(formData.extra_table);
    formData.extra_chair = Number(formData.extra_chair);
    formData.table_quantity = Number(formData.table_quantity) || 0;
    formData.chair_quantity = Number(formData.chair_quantity) || 0;
    formData.amount = Number(formData.amount) || 0;
    updateSubscription(formData, id).then(() => {
      showToast("Alterado com sucesso!", { severity: "success" });
      updateSubscriptions();
    }).catch(() => {
      showToast("Erro ao atualizar inscrição!", { severity: "error" });
    });
    handleClose();
  };

  return (
    <>
      <ModalComponent open={open} handleClose={handleClose} title="Editando as informações da Inscrição" maxWidth={isMobile ? "90%" : 700} autoHeight>
          <form onSubmit={handleSubmit}>
            <Box sx={{ p: 0, display: "flex", flexDirection: "column", gap: 3 }}>
              <FormControl size="small">
                <InputLabel id="is-paid-label">Pagamento efetuado</InputLabel>
                <Select
                  labelId="is-paid-label"
                  name="is_paid"
                  label="Pagamento efetuado"
                  defaultValue={sub.is_paid.toString()}
                >
                  <MenuItem value={"true"}>Sim</MenuItem>
                  <MenuItem value={"false"}>Não</MenuItem>
                </Select>
              </FormControl>

              <FormControl size="small">
                <InputLabel id="status-label">Status da Inscrição</InputLabel>
                <Select
                  labelId="status-label"
                  name="status_id"
                  label="Status da Inscrição"
                  defaultValue={sub.status_id}
                >
                  <MenuItem value={0}>Em Análise</MenuItem>
                  <MenuItem value={1}>Aceito</MenuItem>
                  <MenuItem value={2}>Recusado</MenuItem>
                </Select>
              </FormControl>

              <TextField
                name="event_space"
                type="number"
                label="Posição no Croqui"
                defaultValue={sub.event_space}
                size="small"
              />

              <Typography variant="body2" sx={{ color: "#24324D" }}>
                Dados da Inscrição
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="space-type-label">Tipo de Espaço</InputLabel>
                    <Select
                      labelId="space-type-label"
                      name="space_type"
                      label="Tipo de Espaço"
                      defaultValue={sub.space_type || ""}
                    >
                      <MenuItem value="shared">Compartilhado</MenuItem>
                      <MenuItem value="exclusive">Exclusivo</MenuItem>
                      <MenuItem value="1_tendas">1 Tenda</MenuItem>
                      <MenuItem value="2_tendas">2 Tendas</MenuItem>
                      <MenuItem value="autoral">Marcas Autorais</MenuItem>
                      <MenuItem value="alimentacao">Praça de Alimentação</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <TextField
                    fullWidth
                    size="small"
                    type="date"
                    label="Data de Início"
                    name="start_date"
                    defaultValue={parseDateHifen(sub.start_date)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <TextField
                    fullWidth
                    size="small"
                    type="date"
                    label="Data de Fim"
                    name="end_date"
                    defaultValue={parseDateHifen(sub.end_date)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item xs={6} sm={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="extra-table-label">Mesa Extra</InputLabel>
                    <Select
                      labelId="extra-table-label"
                      name="extra_table"
                      label="Mesa Extra"
                      defaultValue={sub.extra_table ? 1 : 0}
                    >
                      <MenuItem value={1}>Sim</MenuItem>
                      <MenuItem value={0}>Não</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    label="Qtd. Mesas"
                    name="table_quantity"
                    defaultValue={sub.table_quantity || 0}
                  />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="extra-chair-label">Cadeira Extra</InputLabel>
                    <Select
                      labelId="extra-chair-label"
                      name="extra_chair"
                      label="Cadeira Extra"
                      defaultValue={sub.extra_chair ? 1 : 0}
                    >
                      <MenuItem value={1}>Sim</MenuItem>
                      <MenuItem value={0}>Não</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    label="Qtd. Cadeiras"
                    name="chair_quantity"
                    defaultValue={sub.chair_quantity || 0}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Itens"
                    name="items"
                    defaultValue={sub.items || ""}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    label="Valor (R$)"
                    name="amount"
                    defaultValue={sub.amount || 0}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Observação"
                    name="notes"
                    defaultValue={sub.notes || ""}
                    multiline
                    rows={2}
                  />
                </Grid>
              </Grid>

              <Box
                sx={{
                  pt: 2,
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row-reverse",
                  justifyContent: isMobile ? "flex-end" : "flex-start",
                  gap: 2,
                }}
              >
                <Button
                  variant="contained"
                  type="submit"
                  sx={adminButtonPrimarySx}
                  fullWidth={isMobile}
                >
                  Alterar
                </Button>
                <Button
                  onClick={handleClose}
                  sx={adminButtonOutlinedSx}
                  fullWidth={isMobile}
                >
                  Cancelar
                </Button>
              </Box>
            </Box>
          </form>
      </ModalComponent>
      <IconButton
        onClick={() => {
          handleOpen();
          updateSubscriptions();
        }}
      >
        <EditIcon />
      </IconButton>
    </>
  );
}
